import { AlertService } from './../../shared/services/alert.service';
import { Injectable } from '@angular/core';
import { act, Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';


import * as fromActions from './slot.actions';
import { mergeMap, map, catchError } from 'rxjs/operators';
import {
    IShopPerDayResponse,
    IShopPerTimeResponse,
    IMasterSlotsResponse,
    ITeamPerDayResponse,
    ITeamPerTimeResponse,
    ITeamPerTimePerTeamResponse,
    ITechniciansPerDayResponse,
    ITechniciansAllTeamResponse,
    ITechnicianPerTeamResponse,
    ITransportSlotsResponse,
    IRemotePerDayResponse,
    IRemotePerTimeResponse,
    IActivateIndicatorsResponse
} from '../../shared/models/slot-management.model';
import { SlotService } from '../../shared/services/slot.service';
import * as fromAdapter from './slot.adapter';

@Injectable()
export class SlotEffects {
    private availabilityType = 'service';
    somethingWentWrongPleaseTryAgain = 'otherTexts.somethingWentWrongPleaseTryAgain';
    timePeriodBasedCapacityOFF = 'otherTexts.timePeriodBasedCapacityOFF';
    timePeriodBasedCapacityON = 'otherTexts.timePeriodBasedCapacityON';
    slotDetailsUpdatedSuccessfully = 'otherTexts.slotDetailsUpdatedSuccessfully';

    
    loadMasterSlots: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadMasterSlots>(
            fromActions.SlotActionTypes.LOAD_MASTER_SLOTS
        ),
        mergeMap((action: fromActions.LoadMasterSlots) =>
            this.slotService.getMasterSlots(this.availabilityType).pipe(
                map((masterSlots: IMasterSlotsResponse) => new fromActions.LoadMasterSlotsSuccess({ masterSlots: masterSlots.data })),
                catchError(err => of(new fromActions.LoadMasterSlotsFailure({ error: err })))
            )
        )
    ));

    
    LoadActivateIndicators: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadActivateIndicators>(
            fromActions.SlotActionTypes.LOAD_ACTIVATE_INDICATOR
        ),
        mergeMap((action: fromActions.LoadActivateIndicators) =>
            this.slotService.getActivateIndicators(this.availabilityType, 'team').pipe(
                map((activateIndicators: IActivateIndicatorsResponse) => new fromActions.LoadActivateIndicatorsSuccess({ activateIndicators: activateIndicators.data })),
                catchError(err => of(new fromActions.LoadActivateIndicatorsFailure({ error: err })))
            )
        )
    ));

    
    updateActivateIndicators: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateActivateIndicators>(
            fromActions.SlotActionTypes.UPDATE_ACTIVATE_INDICATOR
        ),
        mergeMap((action: fromActions.UpdateActivateIndicators) =>
            this.slotService.updateActivateIndicators(action.payload.indicator, this.availabilityType, 'team').pipe(
                map((response: IActivateIndicatorsResponse) => {
                    var alert="otherTexts.teamSlotsDeactivated";
                    if(response.data['indicator']){
                        alert='otherTexts.teamSlotsActivated';
                    }
                    this.alertService.showAlert(alert, '', '', 5000, false);
                    return new fromActions.UpdateActivateIndicatorsSuccess({ activateIndicators: response.data })
                }),
                catchError(err => {
                    this.alertService.showAlert(this.somethingWentWrongPleaseTryAgain);
                    return of(new fromActions.UpdateActivateIndicatorsFailure({ error: err }))
                })
            )
        )
    ));

    
    LoadTechnicianActivateIndicators: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadTechnicianActivateIndicators>(
            fromActions.SlotActionTypes.LOAD_TECHNICIAN_ACTIVATE_INDICATOR
        ),
        mergeMap((action: fromActions.LoadTechnicianActivateIndicators) =>
            this.slotService.getActivateIndicators(this.availabilityType, 'technician').pipe(
                map((technicianactivateIndicators: IActivateIndicatorsResponse) => new fromActions.LoadTechnicianActivateIndicatorsSuccess({ technicianactivateIndicators: technicianactivateIndicators.data })),
                catchError(err => of(new fromActions.LoadTechnicianActivateIndicatorsFailure({ error: err })))
            )
        )
    ));

    
    updateTechnicianActivateIndicators: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateTechnicianActivateIndicators>(
            fromActions.SlotActionTypes.UPDATE_TECHNICIAN_ACTIVATE_INDICATOR
        ),
        mergeMap((action: fromActions.UpdateTechnicianActivateIndicators) =>
            this.slotService.updateActivateIndicators(action.payload.indicator, this.availabilityType, 'technician').pipe(
                map((response: IActivateIndicatorsResponse) => {
                    var alert='otherTexts.technicianHoursDeactivated';
                    if(response.data['indicator']){
                        alert='otherTexts.technicianHoursActivated';
                    }
                    this.alertService.showAlert(alert, '', '', 5000, false);
                    return new fromActions.UpdateTechnicianActivateIndicatorsSuccess({ technicianactivateIndicators: response.data })
                }),
                catchError(err => {
                    this.alertService.showAlert(this.somethingWentWrongPleaseTryAgain);
                    return of(new fromActions.UpdateTechnicianActivateIndicatorsFailure({ error: err }))
                })
            )
        )
    ));

    
    LoadShuttleActivateIndicators: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadShuttleActivateIndicators>(
            fromActions.SlotActionTypes.LOAD_SHUTTLE_ACTIVATE_INDICATOR
        ),
        mergeMap((action: fromActions.LoadShuttleActivateIndicators) =>
            this.slotService.getActivateIndicators(this.availabilityType, 'shuttle').pipe(
                map((shuttleactivateIndicators: IActivateIndicatorsResponse) => new fromActions.LoadShuttleActivateIndicatorsSuccess({ shuttleactivateIndicators: shuttleactivateIndicators.data })),
                catchError(err => of(new fromActions.LoadShuttleActivateIndicatorsFailure({ error: err })))
            )
        )
    ));

    
    updateShuttleActivateIndicators: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateShuttleActivateIndicators>(
            fromActions.SlotActionTypes.UPDATE_SHUTTLE_ACTIVATE_INDICATOR
        ),
        mergeMap((action: fromActions.UpdateShuttleActivateIndicators) =>
            this.slotService.updateActivateIndicators(action.payload.indicator, this.availabilityType, 'shuttle').pipe(
                map((response: IActivateIndicatorsResponse) => {
                    var alert=this.timePeriodBasedCapacityOFF;
                    if(response.data['indicator']){
                        alert=this.timePeriodBasedCapacityON;
                    }
                    this.alertService.showAlert(alert, '', '', 5000, false);
                    return new fromActions.UpdateShuttleActivateIndicatorsSuccess({ shuttleactivateIndicators: response.data })
                }),
                catchError(err => {
                    this.alertService.showAlert(this.somethingWentWrongPleaseTryAgain);
                    return of(new fromActions.UpdateShuttleActivateIndicatorsFailure({ error: err }))
                })
            )
        )
    ));

    
    LoadRentalActivateIndicators: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadRentalActivateIndicators>(
            fromActions.SlotActionTypes.LOAD_RENTAL_ACTIVATE_INDICATOR
        ),
        mergeMap((action: fromActions.LoadRentalActivateIndicators) =>
            this.slotService.getActivateIndicators(this.availabilityType, 'rental').pipe(
                map((rentalactivateIndicators: IActivateIndicatorsResponse) => new fromActions.LoadRentalActivateIndicatorsSuccess({ rentalactivateIndicators: rentalactivateIndicators.data })),
                catchError(err => of(new fromActions.LoadRentalActivateIndicatorsFailure({ error: err })))
            )
        )
    ));

    
    updateRentalActivateIndicators: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateRentalActivateIndicators>(
            fromActions.SlotActionTypes.UPDATE_RENTAL_ACTIVATE_INDICATOR
        ),
        mergeMap((action: fromActions.UpdateRentalActivateIndicators) =>
            this.slotService.updateActivateIndicators(action.payload.indicator, this.availabilityType, 'rental').pipe(
                map((response: IActivateIndicatorsResponse) => {
                    var alert=this.timePeriodBasedCapacityOFF;
                    if(response.data['indicator']){
                        alert=this.timePeriodBasedCapacityON;
                    }
                    this.alertService.showAlert(alert, '', '', 5000, false);
                    return new fromActions.UpdateRentalActivateIndicatorsSuccess({ rentalactivateIndicators: response.data })
                }),
                catchError(err => {
                    this.alertService.showAlert(this.somethingWentWrongPleaseTryAgain);
                    return of(new fromActions.UpdateRentalActivateIndicatorsFailure({ error: err }))
                })
            )
        )
    ));

   

    
    LoadRemoteActivateIndicators: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadRemoteActivateIndicators>(
            fromActions.SlotActionTypes.LOAD_REMOTE_ACTIVATE_INDICATOR
        ),
        mergeMap((action: fromActions.LoadRemoteActivateIndicators) =>
            this.slotService.getActivateIndicators(this.availabilityType, 'remote').pipe(
                map((remoteactivateIndicators: IActivateIndicatorsResponse) => new fromActions.LoadRemoteActivateIndicatorsSuccess({ remoteactivateIndicators: remoteactivateIndicators.data })),
                catchError(err => of(new fromActions.LoadRemoteActivateIndicatorsFailure({ error: err })))
            )
        )
    ));

    
    updateRemoteActivateIndicators: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateRemoteActivateIndicators>(
            fromActions.SlotActionTypes.UPDATE_REMOTE_ACTIVATE_INDICATOR
        ),
        mergeMap((action: fromActions.UpdateRemoteActivateIndicators) =>
            this.slotService.updateActivateIndicators(action.payload.indicator, this.availabilityType, 'remote').pipe(
                map((response: IActivateIndicatorsResponse) => {
                    var alert=this.timePeriodBasedCapacityOFF;
                    if(response.data['indicator']){
                        alert=this.timePeriodBasedCapacityON;
                    }
                    this.alertService.showAlert(alert, '', '', 5000, false);
                    return new fromActions.UpdateRemoteActivateIndicatorsSuccess({ remoteactivateIndicators: response.data })
                }),
                catchError(err => {
                    this.alertService.showAlert(this.somethingWentWrongPleaseTryAgain);
                    return of(new fromActions.UpdateRemoteActivateIndicatorsFailure({ error: err }))
                })
            )
        )
    ));

    
    loadShopMaxTotal: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadShopMaxTotal>(
            fromActions.SlotActionTypes.LOAD_SHOP_MAX_TOTAL
        ),
        mergeMap((action: fromActions.LoadShopMaxTotal) =>
            this.slotService.getShopMaxTotal(this.availabilityType).pipe(
                map((response: IShopPerDayResponse) => new fromActions.LoadShopMaxTotalSuccess({ shopMaxTotal: response.data })),
                catchError(err => of(new fromActions.LoadShopMaxTotalFailure({ error: err })))
            )
        )
    ));

    
    loadShopMaxSlots: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadShopMaxSlots>(
            fromActions.SlotActionTypes.LOAD_SHOP_MAX_SLOTS
        ),
        mergeMap((action: fromActions.LoadShopMaxSlots) =>
            this.slotService.getShopMaxSlots(this.availabilityType).pipe(
                map((shopMaxSlots: IShopPerTimeResponse) =>
                new fromActions.LoadShopMaxSlotsSuccess(
                    { shopMaxSlots: fromAdapter.enrichShopMaxSlots(shopMaxSlots.data) })),
                catchError(err => of(new fromActions.LoadShopMaxSlotsFailure({ error: err })))
            )
        )
    ));

    
    updateShopMaxTotal: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateShopMaxTotal>(
            fromActions.SlotActionTypes.UPDATE_SHOP_MAX_TOTAL
        ),
        mergeMap((action: fromActions.UpdateShopMaxTotal) =>
            this.slotService.updateShopMaxTotal(action.payload.shopMaxTotal, this.availabilityType).pipe(
                map((response: IShopPerDayResponse) => {
                    this.alertService.showAlert(this.slotDetailsUpdatedSuccessfully, '', '', 5000, false);
                    return new fromActions.UpdateShopMaxTotalSuccess({ shopMaxTotal: response.data })
                }),
                catchError(err => {
                    this.alertService.showAlert(this.somethingWentWrongPleaseTryAgain);
                    return of(new fromActions.UpdateShopMaxTotalFailure({ error: err }))
                })
            )
        )
    ));

    
    updateShopMaxSlots: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateShopMaxSlots>(
            fromActions.SlotActionTypes.UPDATE_SHOP_MAX_SLOTS
        ),
        mergeMap((action: fromActions.UpdateShopMaxSlots) =>
            this.slotService.updateShopMaxSlots(action.payload.shopMaxSlots, this.availabilityType).pipe(
                map((response: IShopPerTimeResponse) => {
                    if(!action.payload.bothFormsEdited)
                    {
                    this.alertService.showAlert(this.slotDetailsUpdatedSuccessfully, '', '', 5000, false);
                    }
                    return new fromActions.UpdateShopMaxSlotsSuccess({ shopMaxSlots: response.data })
                }),
                catchError(err => {
                    if(!action.payload.bothFormsEdited)
                    {
                    this.alertService.showAlert(this.somethingWentWrongPleaseTryAgain);
                    }
                    return of(new fromActions.UpdateShopMaxSlotsFailure({ error: err }))
                })
            )
        )
    ));

    /*team capacity */
    
    loadTeamMaxTotal: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadTeamMaxTotal>(
            fromActions.SlotActionTypes.LOAD_TEAM_MAX_TOTAL
        ),
        mergeMap((action: fromActions.LoadTeamMaxTotal) =>
            this.slotService.getTeamMaxTotal(this.availabilityType).pipe(
                map((response: ITeamPerDayResponse) => new fromActions.LoadTeamMaxTotalSuccess({ teamMaxTotal: response.data })),
                catchError(err => of(new fromActions.LoadTeamMaxTotalFailure({ error: err })))
            )
        )
    ));

    
    loadTeamMaxSlots: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadTeamMaxSlots>(
            fromActions.SlotActionTypes.LOAD_TEAM_MAX_SLOTS
        ),
        mergeMap((action: fromActions.LoadTeamMaxSlots) =>
            this.slotService.getTeamMaxSlots(this.availabilityType).pipe(
                map((shopMaxSlots: ITeamPerTimeResponse) =>
                new fromActions.LoadTeamMaxSlotsSuccess(
                    { teamMaxSlots: fromAdapter.enrichTeamMaxSlots(shopMaxSlots.data) })),
                catchError(err => of(new fromActions.LoadTeamMaxSlotsFailure({ error: err })))
            )
        )
    ));

    
    updateTeamMaxTotal: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateTeamMaxTotal>(
            fromActions.SlotActionTypes.UPDATE_TEAM_MAX_TOTAL
        ),
        mergeMap((action: fromActions.UpdateTeamMaxTotal) =>
            this.slotService.updateTeamMaxTotal(action.payload.teamMaxTotal, this.availabilityType).pipe(
                map((response: ITeamPerDayResponse) => {
                    if(!action.payload.allFormsEdited)
                    {
                    this.alertService.showAlert('otherTexts.teamsSlotDetailsUpdatedSuccessfully', '', '', 5000, false);
                    }
                    return new fromActions.UpdateTeamMaxTotalSuccess({ teamMaxTotal: response.data })
                }),
                catchError(err => {
                    if(!action.payload.allFormsEdited)
                    {
                    this.alertService.showAlert(this.somethingWentWrongPleaseTryAgain);
                    }
                    return of(new fromActions.UpdateTeamMaxTotalFailure({ error: err }))
                })
            )
        )
    ));

    
    updateTeamMaxSlots: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateTeamMaxSlots>(
            fromActions.SlotActionTypes.UPDATE_TEAM_MAX_SLOTS
        ),
        mergeMap((action: fromActions.UpdateTeamMaxSlots) =>
            this.slotService.updateTeamMaxSlots(action.payload.teamMaxSlots, this.availabilityType).pipe(
                map((response: ITeamPerTimePerTeamResponse) => {
                    if(!action.payload.allFormsEdited)
                    {
                    this.alertService.showAlert('otherTexts.teamsSlotDetailsUpdatedSuccessfully', '', '', 5000, false);
                    }
                    return new fromActions.UpdateTeamMaxSlotsSuccess({ teamMaxSlots: response.data })
                }),
                catchError(err => {
                    if(!action.payload.allFormsEdited)
                    {
                    this.alertService.showAlert(this.somethingWentWrongPleaseTryAgain);
                    }
                    return of(new fromActions.UpdateTeamMaxSlotsFailure({ error: err }))
                })
            )
        )
    ));

    /*technician capacity */
    
    loadTechnicianTotal: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadTechnicianMaxTotal>(
            fromActions.SlotActionTypes.LOAD_TECHNICIAN_MAX_TOTAL
        ),
        mergeMap((action: fromActions.LoadTechnicianMaxTotal) =>
            this.slotService.getTechnicianTotal(this.availabilityType).pipe(
                map((response: ITechniciansPerDayResponse) => new fromActions.LoadTechnicianMaxTotalSuccess({ technicianMaxTotal: response.data })),
                catchError(err => of(new fromActions.LoadTechnicianMaxTotalFailure({ error: err })))
            )
        )
    ));

    
    loadTechnicianSlots: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadTechnicianMaxSlots>(
            fromActions.SlotActionTypes.LOAD_TECHNICIAN_MAX_SLOTS
        ),
        mergeMap((action: fromActions.LoadTechnicianMaxSlots) =>
            this.slotService.getTechnicianSlots(this.availabilityType).pipe(
                map((shopMaxSlots: ITechniciansAllTeamResponse) => new fromActions.LoadTechnicianMaxSlotsSuccess({ technicianMaxSlots: shopMaxSlots.data })),
                catchError(err => of(new fromActions.LoadTechnicianMaxSlotsFailure({ error: err })))
            )
        )
    ));

    
    updateTechnicianTotal: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateTechnicianMaxTotal>(
            fromActions.SlotActionTypes.UPDATE_TECHNICIAN_MAX_TOTAL
        ),
        mergeMap((action: fromActions.UpdateTechnicianMaxTotal) =>
            this.slotService.updateTechnicianTotal(action.payload.technicianMaxTotal, this.availabilityType).pipe(
                map((response: ITechniciansPerDayResponse) => {
                    this.alertService.showAlert('otherTexts.technicianSlotDetailsUpdatedSuccessfully', '', '', 5000, false);
                    return new fromActions.UpdateTechnicianMaxTotalSuccess({ technicianMaxTotal: response.data })
                }),
                catchError(err => {
                    this.alertService.showAlert(this.somethingWentWrongPleaseTryAgain);
                    return of(new fromActions.UpdateTechnicianMaxTotalFailure({ error: err }))
                })
            )
        )
    ));

    
    updateTechnicianSlots: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateTechnicianMaxSlots>(
            fromActions.SlotActionTypes.UPDATE_TECHNICIAN_MAX_SLOTS
        ),
        mergeMap((action: fromActions.UpdateTechnicianMaxSlots) =>
            this.slotService.updateTechnicianSlots(action.payload.technicianMaxSlots, this.availabilityType).pipe(
                map((response: ITechnicianPerTeamResponse) => {
                    this.alertService.showAlert('otherTexts.technicianSlotDetailsUpdatedSuccessfully', '', '', 5000, false);
                    return new fromActions.UpdateTechnicianMaxSlotsSuccess({ technicianMaxSlots: response.data })
                }),
                catchError(err => {
                    this.alertService.showAlert(this.somethingWentWrongPleaseTryAgain);
                    return of(new fromActions.UpdateTechnicianMaxSlotsFailure({ error: err }))
                })
            )
        )
    ));

    /* transport capacity */
    
    loadTransportMaxTotal: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadTransportMaxTotal>(
            fromActions.SlotActionTypes.LOAD_TRANSPORT_MAX_TOTAL
        ),
        mergeMap((action: fromActions.LoadTransportMaxTotal) =>
            this.slotService.getTransportMaxTotal(action.payload.transport, this.availabilityType).pipe(
                map((response: IRemotePerDayResponse) => new fromActions.LoadTransportMaxTotalSuccess(
                    { transport: action.payload.transport ,transportMaxTotal: response.data })),
                catchError(err => of(new fromActions.LoadTransportMaxTotalFailure({ error: err })))
            )
        )
    ));

    
    loadTransportMaxSlots: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadTransportMaxSlots>(
            fromActions.SlotActionTypes.LOAD_TRANSPORT_MAX_SLOTS
        ),
        mergeMap((action: fromActions.LoadTransportMaxSlots) =>
            this.slotService.getTransportMaxSlots(action.payload.transport, this.availabilityType).pipe(
                map((response: IRemotePerTimeResponse) => new fromActions.LoadTransportMaxSlotsSuccess(
                    { transport: action.payload.transport, transportMaxSlots: fromAdapter.enrichShopMaxSlots(response.data) })),
                catchError(err => of(new fromActions.LoadTransportMaxSlotsFailure({ error: err })))
            )
        )
    ));

    
    updateTransportMaxTotal: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateTransportMaxTotal>(
            fromActions.SlotActionTypes.UPDATE_TRANSPORT_MAX_TOTAL
        ),
        mergeMap((action: fromActions.UpdateTransportMaxTotal) =>
            this.slotService.updateTransportMaxTotal(action.payload.transport, action.payload.transportMaxTotal, this.availabilityType).pipe(
                map((response: IRemotePerDayResponse) => {
                    this.alertService.showAlert(this.slotDetailsUpdatedSuccessfully, '', '', 5000, false);
                    return new fromActions.UpdateTransportMaxTotalSuccess(
                        { transport: action.payload.transport, transportMaxTotal: response.data })
                }),
                catchError(err => {
                    this.alertService.showAlert(this.somethingWentWrongPleaseTryAgain);
                    return of(new fromActions.UpdateTransportMaxTotalFailure({ error: err }))
                })
            )
        )
    ));

    
    updateTransportMaxSlots: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateTransportMaxSlots>(
            fromActions.SlotActionTypes.UPDATE_TRANSPORT_MAX_SLOTS
        ),
        mergeMap((action: fromActions.UpdateTransportMaxSlots) =>
            this.slotService.updateTransportMaxSlots(action.payload.transport, action.payload.transportMaxSlots, this.availabilityType).pipe(
                map((response: IRemotePerTimeResponse) => {
                    if(!action.payload.bothFormsEdited)
                    {
                    this.alertService.showAlert(this.slotDetailsUpdatedSuccessfully, '', '', 5000, false);
                    }
                    return new fromActions.UpdateTransportMaxSlotsSuccess(
                        { transport: action.payload.transport, transportMaxSlots: response.data })
                }),
                catchError(err => {
                    if(!action.payload.bothFormsEdited)
                    {
                    this.alertService.showAlert(this.somethingWentWrongPleaseTryAgain);
                    }
                    return of(new fromActions.UpdateTransportMaxSlotsFailure({ error: err }))
                })
            )
        )
    ));
    /* txm Team capacity */
    
    loadTxmTeamMaxTotal: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadTxmTeamMaxTotal>(
            fromActions.SlotActionTypes.LOAD_TXM_TEAM_MAX_TOTAL
        ),
        mergeMap((action: fromActions.LoadTxmTeamMaxTotal) =>
            this.slotService.getTxmTeamMaxTotal(this.availabilityType).pipe(
                map((response: IRemotePerDayResponse) => new fromActions.LoadTxmTeamMaxTotalSuccess(
                    { txmTeamMaxTotal: response.data })),
                catchError(err => of(new fromActions.LoadTxmTeamMaxTotalFailure({ error: err })))
            )
        )
    ));

    
    loadTxmTeamMaxSlots: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadTxmTeamMaxSlots>(
            fromActions.SlotActionTypes.LOAD_TXM_TEAM_MAX_SLOTS
        ),
        mergeMap((action: fromActions.LoadTxmTeamMaxSlots) =>
            this.slotService.getTxmTeamMaxSlots(this.availabilityType).pipe(
                map((response: IRemotePerTimeResponse) => new fromActions.LoadTxmTeamMaxSlotsSuccess(
                    {txmTeamMaxSlots: fromAdapter.enrichShopMaxSlots(response.data) })),
                catchError(err => of(new fromActions.LoadTxmTeamMaxSlotsFailure({ error: err })))
            )
        )
    ));

    
    updateTxmTeamMaxTotal: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateTxmTeamMaxTotal>(
            fromActions.SlotActionTypes.UPDATE_TXM_TEAM_MAX_TOTAL
        ),
        mergeMap((action: fromActions.UpdateTxmTeamMaxTotal) =>
            this.slotService.updateTxmTeamMaxTotal(action.payload.txmTeamMaxTotal, this.availabilityType).pipe(
                map((response: IRemotePerDayResponse) => {
                    this.alertService.showAlert(this.slotDetailsUpdatedSuccessfully, '', '', 5000, false);
                    return new fromActions.UpdateTxmTeamMaxTotalSuccess(
                        {txmTeamMaxTotal: response.data })
                }),
                catchError(err => {
                    this.alertService.showAlert(this.somethingWentWrongPleaseTryAgain);
                    return of(new fromActions.UpdateTxmTeamMaxTotalFailure({ error: err }))
                })
            )
        )
    ));

    
    updateTxmTeamMaxSlots: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateTxmTeamMaxSlots>(
            fromActions.SlotActionTypes.UPDATE_TXM_TEAM_MAX_SLOTS
        ),
        mergeMap((action: fromActions.UpdateTxmTeamMaxSlots) =>
            this.slotService.updateTxmTeamMaxSlots(action.payload.txmTeamMaxSlots, this.availabilityType).pipe(
                map((response: IRemotePerTimeResponse) => {
                    if(!action.payload.bothFormsEdited)
                    {
                    this.alertService.showAlert(this.slotDetailsUpdatedSuccessfully, '', '', 5000, false);
                    }
                    return new fromActions.UpdateTxmTeamMaxSlotsSuccess(
                        {txmTeamMaxSlots: response.data })
                }),
                catchError(err => {
                    if(!action.payload.bothFormsEdited)
                    {
                    this.alertService.showAlert(this.somethingWentWrongPleaseTryAgain);
                    }
                    return of(new fromActions.UpdateTxmTeamMaxSlotsFailure({ error: err }))
                })
            )
        )
    ));
    
    LoadTxmActivateIndicators: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadTxmTeamActivateIndicator>(
            fromActions.SlotActionTypes.LOAD_TXM_TEAM_ACTIVATE_INDICATOR
        ),
        mergeMap((action: fromActions.LoadTxmTeamActivateIndicator) =>
            this.slotService.getActivateIndicators(this.availabilityType, 'txm').pipe(
                map((txmActivateIndicators: IActivateIndicatorsResponse) => new fromActions.LoadTxmTeamActivateIndicatorSuccess({ txmActivateIndicators: txmActivateIndicators.data })),
                catchError(err => of(new fromActions.LoadTxmTeamActivateIndicatorFailure({ error: err })))
            )
        )
    ));

    
    updateTxmActivateIndicators: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateTxmTeamActivateIndicator>(
            fromActions.SlotActionTypes.UPDATE_TXM_TEAM_ACTIVATE_INDICATOR
        ),
        mergeMap((action: fromActions.UpdateTxmTeamActivateIndicator) =>
            this.slotService.updateActivateIndicators(action.payload.indicator, this.availabilityType, 'txm').pipe(
                map((response: IActivateIndicatorsResponse) => {
                    var alert=this.timePeriodBasedCapacityOFF;
                    if(response.data['indicator']){
                        alert=this.timePeriodBasedCapacityON;
                    }
                    this.alertService.showAlert(alert, '', '', 5000, false);
                    return new fromActions.UpdateTxmTeamActivateIndicatorSuccess({ txmActivateIndicators: response.data })
                }),
                catchError(err => {
                    this.alertService.showAlert(this.somethingWentWrongPleaseTryAgain);
                    return of(new fromActions.UpdateTxmTeamActivateIndicatorFailure({ error: err }))
                })
            )
        )
    ));


    constructor(
        private actions$: Actions,
        private slotService: SlotService,
        private alertService: AlertService
    ) {
    }
}
